<div class="p-24 pt-8">
    <div *ngIf="Content" class="file-details">
        <div
            fxLayout="row wrap"
            fxLayoutGap="8px"
            fxLayoutAlign="start center"
            *ngIf="sharedPersonList && sharedPersonList.length > 0 && detailsConfig && detailsConfig.isShowPersons"
        >
            <div class="mb-8">{{ "APP_PLATFORM_DOCUMENT_MANAGER.SHARE_PERSON" | translate }}:</div>
            <ng-container *ngFor="let person of sharedPersonList">
                <ngx-avatars
                    name="{{ person.DisplayName }}"
                    src="{{ person.ProfileImage }}"
                    matTooltip="{{ person.DisplayName }}"
                    [size]="32"
                    matTooltipPosition="below"
                    matTooltipClass="share-person-tooltip"
                    class="mb-8"
                    [fgColor]="person.TextColorCode"
                    [bgColor]="person.ColorCode"
                >
                </ngx-avatars>
            </ng-container>
        </div>
        <div
            fxLayout="row"
            class="mt-8 pt-8"
            *ngIf="shareRoleList && shareRoleList.length > 0 && detailsConfig && detailsConfig.isShowRoles"
        >
            <div>
                <div class="mb-8">{{ "APP_PLATFORM_DOCUMENT_MANAGER.SHARE_ROLES" | translate }}:</div>
                <ng-container *ngFor="let role of shareRoleList">
                    <span *ngIf="detailsConfig.isShowRoles['dynamicRoleCallback']" class="share_role_name">
                        {{ role }}
                    </span>
                    <span *ngIf="!detailsConfig.isShowRoles['dynamicRoleCallback']" class="share_role_name">
                        {{ roleViewValue(role) }}
                    </span>
                </ng-container>
            </div>
        </div>
        <div class="preview file-icon mr-28 h-120" fxLayout="row" fxLayoutAlign="center start">
            <mat-icon
                class="type-icon info-folder"
                *ngIf="Content?.Type === 'DriveFolder' || Content?.Type === 'SharedFolder'"
                [style.color]="Content?.Color"
            >
                folder_shared
            </mat-icon>
            <!-- <mat-icon class="type-icon s-48" *ngIf="Content?.Type === 'DriveFile' || Content?.Type === 'SharedFile'">
                {{ Content?.IconName }}</mat-icon> -->
            <mat-icon
                class="type-icon"
                *ngIf="Content?.Type === 'DriveFile' || Content?.Type === 'SharedFile'"
                [class]="Content?.IconName"
            >
            </mat-icon>
        </div>
        <mat-divider></mat-divider>

        <div class="title mt-16">{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_INFO_TITLE" | translate }}</div>

        <div fxLayout="column">
            <div fxLayout="row" class="my-12">
                <div fxFlex="40">
                    <label class="font-weight-600">{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_TYPE" | translate }}</label>
                </div>
                <div fxFlex="60">
                    <span *ngIf="Content?.Type === 'DriveFolder' || Content?.Type === 'SharedFolder'">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER" | translate }}
                    </span>
                    <span *ngIf="Content?.Type === 'DriveFile' || Content?.Type === 'SharedFile'">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_DOCUMENT_FILE" | translate }}
                    </span>
                </div>
            </div>

            <div fxLayout="row" class="my-12" *ngIf="Content.FileSizeInKB > 0">
                <div fxFlex="40">
                    <label class="font-weight-600">{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SIZE" | translate }}</label>
                </div>
                <div fxFlex="60">
                    <!-- <span>{{ Content?.FileSizeInKB }} KB</span> -->
                    <span>{{(Content?.FileSizeInKB*1024 | fileSize: "1.0-2")}}</span>
                </div>
            </div>

            <div fxLayout="row" class="my-12">
                <div fxFlex="40">
                    <label class="font-weight-600">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_CREATED_AT" | translate }}
                    </label>
                </div>
                <div fxFlex="60">
                    <span>{{ Content?.CreateDate | date: 'dd.MM.yyyy. h:mm a' }}</span>
                </div>
            </div>

            <div fxLayout="row" class="my-12" *ngIf="detailsConfig.showAccessType">
                <div fxFlex="40">
                    <label class="font-weight-600">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_ACCESS_TYPE" | translate }}
                    </label>
                </div>
                <div fxFlex="60">
                    <span *ngIf="ContentAsObjectArtifact?.Secured">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.SECURE_STRATEGY" | translate }}
                    </span>
                    <span *ngIf="!ContentAsObjectArtifact?.Secured">
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.PRIVATE_STRATEGY" | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!Content" fxLayoutAlign="center center">
        <span>{{ "APP_PLATFORM_DOCUMENT_MANAGER.NO_FILE_OR_FOLDER_SELECTED" | translate }}</span>
    </div>
</div>
